export default __webpack_public_path__ + "static/media/national-regular.d4b55e40.ttf";